"use client";

import { iTrustPilotBlockData } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { useEffect } from "react";

// Add type declaration for Trustpilot
declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element) => void;
    };
  }
}

interface TrustPilotSectionProps extends iTrustPilotBlockData {
  heading?: string;
}

export function TrustPilotSection({
  heading,
  businessUnitId,
  templateId,
  widgetHeight,
}: TrustPilotSectionProps) {
  useEffect(() => {
    if (!businessUnitId || !templateId) {
      return;
    }

    const loadTrustpilotWidgets = () => {
      const elements = document.getElementsByClassName("trustpilot-widget");
      Array.from(elements).forEach((element) => {
        window.Trustpilot?.loadFromElement(element);
      });
    };

    if (!window.Trustpilot) {
      const script = document.createElement("script");
      script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onerror = () => console.error("Failed to load Trustpilot widget");
      script.onload = loadTrustpilotWidgets;
      document.head.appendChild(script);
    } else {
      loadTrustpilotWidgets();
    }

    // Cleanup
    return () => {
      const script = document.querySelector(
        'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]'
      );
      if (script) {
        script.remove();
      }
    };
  }, [businessUnitId, templateId]);

  return (
    <section className="bg-white rounded-lg shadow-md p-6 space-y-8">
      {heading && <h2 className="text-2xl font-semibold mb-6">{heading}</h2>}

      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id={templateId}
        data-businessunit-id={businessUnitId}
        data-style-height={`${widgetHeight || 240}px`}
        data-style-width="100%"
        data-theme="light"
      >
        <a
          href={`https://uk.trustpilot.com/review/${businessUnitId}`}
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
    </section>
  );
}
